// The builder's own identity for the requester rules in rfq-requesters.ts:
// its email domains, staff names and staff emails are never a client's.
//
// Kept apart from rfq-requesters.ts so that module stays pure. Never throws:
// without a readable tenant profile the email guard still drops every email
// that is not printed in the source, and only the builder-domain rule is lost.

import { getInstanceOwner, getInstanceOwnerCached } from './tenant-resolver';
import { requesterTenantContextFromOwner, type RequesterTenantContext } from './rfq-requesters';

export function cachedRequesterTenantContext(): RequesterTenantContext {
    try {
        return requesterTenantContextFromOwner(getInstanceOwnerCached({ orLastGood: true }));
    } catch {
        return {};
    }
}

export async function loadRequesterTenantContext(): Promise<RequesterTenantContext> {
    try {
        return requesterTenantContextFromOwner(await getInstanceOwner());
    } catch {
        return cachedRequesterTenantContext();
    }
}
